<template>
  <div class="card p-4">
    <div class="headerWrapper">
      <div>
        <WeekRange :startDate="startDate" @dateUpdate="dateUpdate" />
      </div>
      <div>
        <div
          style="display:grid;grid-template-columns: auto 175px;justify-items: end"
        >
          <div>
            <b-dropdown id="dropdown-1" text="Actions" variant="outline-light">
              <b-dropdown-item @click="deleteAllItems"
                >Delete all items</b-dropdown-item
              >
              <b-dropdown-item @click="copy(7)"
                >Copy to next week</b-dropdown-item
              >
              <b-dropdown-item @click="copy(-7)"
                >Copy to previous week</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <div>
            <b-button
              v-bind:class="{
                'btn-success': publishCount > 0,
                'btn-outline-light': publishCount == 0,
              }"
              @click.prevent="publish"
              >Publish {{ publishCount > 0 ? publishCount + " item" : ""
              }}{{ publishCount > 1 ? "s" : "" }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <EditScheduleItem
      ref="editScheduleItem"
      :scheduleItem="activeSchedule"
      :providers="providers"
      @scheduleItemUpdated="scheduleItemUpdated"
    />

    <div class="wrapper mt-4">
      <div>&nbsp;</div>
      <div v-for="day in days">
        <div class="day">{{ day.day }}</div>
        <div class="day2">{{ day.num }}</div>
      </div>
      <template v-for="provider in providers">
        <div>
          <div class="provider">
            <b-avatar />
            <span class="pl-2">
              {{ provider.name }}
            </span>
          </div>
        </div>
        <template v-for="(timeFrame, i1) in provider.timeFrames">
          <div class="timeFrameCellItem">
            <AddItem
              @add="addTimeFrame"
              :provider="provider"
              :day="i1"
              v-if="timeFrame.length == 0"
            />
            <div class="display:grid">
              <template
                v-for="(t, index) in timeFrame"
                v-if="timeFrame.length > 0"
              >
                <DailyItem
                  :timeFrame="t"
                  :day="i1"
                  :provider="provider"
                  @add="addAnotherTimeFrame(i1, timeFrame, provider)"
                  @delete="deleteTimeFrameToArray"
                  @select="selectedTimeFrame"
                />
              </template>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import DailyItem from "@/views/Components/Schedule/DailyItem.vue";
import AddItem from "@/views/Components/Schedule/AddItem.vue";
import EditScheduleItem from "@/views/Components/Schedule/EditScheduleItem.vue";
import WeekRange from "@/views/Components/Schedule/WeekRange.vue";
export default {
  components: { DailyItem, AddItem, EditScheduleItem, WeekRange },
  inject: ["dateService"],
  computed: {
    publishCount() {
      let pc = 0;
      this.providers.forEach((p) => {
        p.timeFrames.forEach((t) => {
          t.forEach((d) => {
            if (!d.isActive || d.isMarkedForDelete) pc++;
          });
        });
      });
      return pc;
    },
  },
  data() {
    return {
      lastNotified: this.getUTCDate(),
      startDate: null,
      activeSchedule: null,
      days: [],
      providers: [],
    };
  },
  created() {
    this.startDate = this.dateService.getPreviousSunday(new Date());
    this.bind();
  },
  methods: {
    copy(offSet) {
      this.$client.post(
        `/api/providerSchedule/copy?startDate=${this.dateService.formatDateForUrl(
          this.startDate
        )}&endDate=${this.dateService.formatDateForUrl(
          this.endDate()
        )}&daysOffSet=${offSet}`
      );
    },
    deleteAllItems() {
      var l = [];
      this.providers.forEach((p) => {
        p.timeFrames.forEach((t, i) => {
          t.forEach((d) => {
            var o = { timeFrame: d, day: i, provider: p };
            l.push(o);
          });
        });
      });

      this.deleteTimeFrame(l);
    },
    async publish() {
      // had to add the dates to qs because c# serializes them correctly vs. form
      // https://stackoverflow.com/questions/56113032/asp-net-datetime-serialization-in-querystring-vs-body

      let r = await this.$client.post(
        `/api/providerSchedule/publish?startDate=${this.dateService.formatDateForUrl(
          this.startDate
        )}&endDate=${this.dateService.formatDateForUrl(this.endDate())}`,
        { noProgress: true }
      );

      if (r.data.isSuccess) {
        this.$emitter.emit("success-confirm", {
          title: "Notified",
          message:
            "The providers on this schedule have been notified of their weekly schedule, and all the changes are active.",
        });
        this.bind();
      }
    },
    endDate() {
      return this.dateService.addDays(this.startDate, 7);
    },
    async bind() {
      let r = await this.$client.get(
        `/api/providerSchedule/getProvidersWeeklySchedule?startDate=${this.dateService.formatDateForUrl(
          this.startDate
        )}&endDate=${this.dateService.formatDateForUrl(this.endDate())}`,
        { noProgress: true }
      );

      this.providers = r.data.value.providers;

      this.days = [];
      for (let i = 0; i < 7; i++) {
        let dt = this.dateService.addDays(this.startDate, i);

        this.days.push({
          day: this.$options.filters.moment(dt, "ddd"),
          num: dt.getDate(),
        });
      }
    },
    deleteTimeFrameToArray(t) {
      this.deleteTimeFrame([t]);
    },
    dateUpdate(newStartDate) {
      this.startDate = newStartDate;
      this.bind();
    },
    getTimeFrameTotal(timeFrames) {
      let total = 0;
      timeFrames.forEach((t) => {
        total += t.endTime24 - t.startTime24;
      });
      return total;
    },

    timeCellDragEnter(e) {
      console.log(e.dataTransfer);
    },
    selectedTimeFrame({ timeFrame, day, provider }) {
      this.activeSchedule = {
        guid: timeFrame.guid,
        startDate: new Date(timeFrame.startDate),
        endDate: new Date(timeFrame.endDate),
        provider: provider,
      };
    },
    scheduleItemUpdated(e) {
      var additions = [];

      e.days.forEach((d) => {
        let newStartDate = this.dateService.addDays(this.startDate, d);

        newStartDate = this.dateService.moveTimeToDate(
          newStartDate,
          e.startDate
        );

        let newEndDate = this.dateService.moveTimeToDate(
          newStartDate,
          e.endDate
        );

        var provider = this.providers.find((p) => p.id == e.providerId);

        if (!e.guid) {
          additions.push({
            provider,
            newStartDate,
            newEndDate,
            newGuid: this.getGuid(),
          });
        }
        // its not new
        else {
          // update what they have
          var timeFrame = provider.timeFrames[d].find((f) => f.guid == e.guid);

          // do they have a time frame
          if (timeFrame) {
            timeFrame.startDate = newStartDate;
            timeFrame.endDate = newEndDate;
            timeFrame.isActive = false;

            this.upsertProviderSchedule([
              {
                guid: timeFrame.guid,
                providerId: provider.id,
                startDate: timeFrame.startDate,
                endDate: timeFrame.endDate,
              },
            ]);
          } else {
            // must of added a new day
            additions.push({
              provider,
              newStartDate,
              newEndDate,
              newGuid: this.getGuid(),
            });
          }
        }
      });
      this.addTimeFrames(additions);
    },
    upsertProviderSchedule(timeFrames) {
      this.$client.post("/api/providerSchedule/upsertProviderSchedule", {
        timeFrames,
      });
    },
    async addTimeFrames(timeFrames) {
      timeFrames.forEach((timeFrame) => {
        var day = new Date(timeFrame.newStartDate).getDay();

        var p = {
          guid: timeFrame.newGuid,
          startDate: timeFrame.newStartDate,
          endDate: timeFrame.newEndDate,
          isActive: false,
          isMarkedForDelete: false,
          hasNeverBeenPublished: true,
        };

        timeFrame.provider.timeFrames[day].push(p);
      });

      this.upsertProviderSchedule(
        timeFrames.map((t) => {
          return {
            guid: t.newGuid,
            providerId: t.provider.id,
            startDate: t.newStartDate,
            endDate: t.newEndDate,
          };
        })
      );
    },
    getUTCDate() {
      var dt = this.$moment.utc();
      return dt.format("YYYY-MM-DDTHH:mm:ss.SSS");
    },
    addTimeFrame(timeFrame) {
      var d = this.dateService.addDays(this.startDate, timeFrame.day);

      this.activeSchedule = {
        startDate: this.dateService.thisDayAt(d, "9:00"),
        endDate: this.dateService.thisDayAt(d, "17:00"),
        provider: timeFrame.provider,
      };
    },
    getGuid() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    addAnotherTimeFrame(day, timeFrame, provider) {
      var d = this.dateService.addDays(this.startDate, day);

      this.activeSchedule = {
        startDate: this.dateService.thisDayAt(d, "9:00"),
        endDate: this.dateService.thisDayAt(d, "17:00"),
        provider: provider,
      };
    },
    async deleteTimeFrame(l) {
      this.$client.post("/api/providerSchedule/deleteProviderSchedule", {
        guids: l.map((t) => t.timeFrame.guid),
        noProgress: true,
      });

      l.forEach((e) => {
        for (var i = 0; i < e.provider.timeFrames[e.day].length; i++) {
          if (e.provider.timeFrames[e.day][i].guid == e.timeFrame.guid) {
            var timeFrame = e.provider.timeFrames[e.day][i];

            // if the timeframe was never live, remove it
            if (!timeFrame.isActive && !timeFrame.isLive) {
              e.provider.timeFrames[e.day].splice(i, 1);
            } else {
              timeFrame.isLive = true;
              timeFrame.isActive = false;
              timeFrame.isMarkedForDelete = true;
            }
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.day {
  font-size: 18px;
  text-transform: uppercase;
  text-align: left;
  color: #7c8287;
  padding: 5px;
}
.day2 {
  font-size: 33px;

  padding: 5px;
  text-align: left;
  color: #7c8287;
}

.headerWrapper {
  display: grid;
  grid-template-columns: 400px auto;
}

.wrapper {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  border: 1px solid #efefe0;
  grid-gap: 1px;
  background-color: #efefe0;
}
.wrapper > div {
  background-color: white;
  padding: 5px;
  text-align: center;
}

.timeFrameCellItem {
}

.timeFrameCellItem:hover * .addTimeFrame {
  display: block;
}

.addTimeFrame {
  display: none;
}

.provider {
  text-align: left;

  color: #7c8287;
  padding-left: 5px;
  padding-top: 5px;
}
</style>
